import React from 'react';
import { mergeClassNames } from '../../../../../../utils';
import styles from './index.module.scss';

/**
 * Shared <label> component for the InputField Components
 */
export default function Label({ children, htmlFor, required, className = null, style = null }) {
  return (
    <label htmlFor={htmlFor} className={mergeClassNames(['label', styles.label, className])} style={style}>
      {children}
      {required ? '*' : null}
    </label>
  );
}
